import React, { useState } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import axios from 'axios';
import PageHeader from './ui/PageHeader';

const TextEditor = () => {
  const [value, setValue] = useState('<p>Hello from CKEditor 5!</p>');
  const apiUrl = 'https://eventplanet.in';
  const uploadEndpoint = 'api/auth/upload';

  function uploadAdapter(loader) {
    return {
      upload: () => {
        return new Promise((resolve, reject) => {
          const body = new FormData();
          loader.file.then((file) => {
            body.append('image', file);
            axios
              .post(`${apiUrl}/${uploadEndpoint}`, body, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                },
              })
              .then((response) => {
                resolve({ default: response.data.url });
              })
              .catch((error) => {
                reject(error);
              });
          });
        });
      },
    };
  }

  function uploadPlugin(editor) {
    editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
      return uploadAdapter(loader);
    };
  }

  return (
    <main className="standalone-page">
      <section className="page-stack">
        <PageHeader
          eyebrow="Editor"
          title="Content Editor"
          description="A focused rich-text editor surface using the same design language as the dashboard."
        />

        <div className="surface-card">
          <div className="editor-shell">
            <CKEditor
              config={{
                extraPlugins: [uploadPlugin],
              }}
              editor={ClassicEditor}
              data={value}
              onChange={(event, editor) => {
                setValue(editor.getData());
              }}
            />
          </div>
        </div>
      </section>
    </main>
  );
};

export default TextEditor;
